import type { PollVoteResponseOptionsItem } from './pollVoteResponseOptionsItem';

export interface PollVoteResponse {
  isExpired?: boolean;
  options?: PollVoteResponseOptionsItem[];
  pollId?: string;
  success?: boolean;
  totalVotes?: number;
  userVoted?: boolean;
  userVotedOptionId?: string;
}
